import React, { useState, useEffect } from "react";
import axios from "axios";
import "./css/profile.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import config from "../config"; // Импортируем API_URL



const Profile = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [avatar, setAvatar] = useState(""); 
  const [error, setError] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    const fetchUserInfo = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Вы не авторизованы.");
        return;
      }

      try {
        const response = await axios.get(`${config.API_URL}/user_info`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUserInfo(response.data);
        setAvatar(
          response.data.avatar
            ? `${config.API_URL}/uploads/${response.data.avatar}`
            : `https://api.dicebear.com/7.x/identicon/svg?seed=${response.data.username}`
        );
      } catch (err) {
        console.error("Ошибка загрузки профиля:", err);
        setError("Ошибка загрузки данных пользователя.");
      }
    };

    fetchUserInfo();
  }, []);

  // Обработчик загрузки аватара
  const handleAvatarChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);

    const formData = new FormData();
    formData.append("avatar", file);

    try {
      const response = await axios.post(`${config.API_URL}/upload_avatar`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setAvatar(response.data.avatar_url);
    } catch (err) {
      console.error("Ошибка загрузки аватарки:", err);
      setError("Не удалось загрузить аватар.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <section className="profile-container">
      <div className="container py-5">
        <div className="row">
          <div className="col">
            {/* <nav className="breadcrumb-container">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="#">Главная</a></li>
                <li className="breadcrumb-item"><a href="#">Пользователь</a></li>
                <li className="breadcrumb-item active">Профиль</li>
              </ol>
            </nav> */}
          </div>
        </div>

        {error ? (
          <p className="error-text">{error}</p>
        ) : userInfo ? (
          <div className="row">
            <div className="col-lg-4">
              <div className="card user-card">
                <div className="card-body text-center">
                  <div className="avatar-wrapper">
                    <div className="avatar-container">
                  <img
                      src={avatar}
                      alt="Аватар"
                      className="rounded-circle img-fluid avatar"
                      onClick={() => document.getElementById("avatarUpload").click()}
                    />
                    <div htmlFor="avatar-upload">
                      <FontAwesomeIcon icon={faCamera} className="camera-icon" />
                    </div>
                    <input
                      type="file"
                      id="avatarUpload"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleAvatarChange}
                    />

                  </div>
                  </div>
                  <h5 className="my-3">{userInfo.username}</h5>
                  <h3 className="text-muted">Айди: {userInfo.telegram_user_id}</h3>
                  <p className="text-muted mb-1">Роль: {userInfo.role}</p>
                  <p className="text-muted mb-4">Группа: {userInfo. group_name ? `${userInfo.group_name}` : "Нет группы"}</p>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3"><p className="mb-0">Никнейм</p></div>
                    <div className="col-sm-9"><p className="text-muted mb-0">{userInfo.username}</p></div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3"><p className="mb-0">Роль</p></div>
                    <div className="col-sm-9"><p className="text-muted mb-0">{userInfo.role}</p></div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3"><p className="mb-0">Группа</p></div>
                    <div className="col-sm-9"><p className="text-muted mb-0">{userInfo.group_id ? `ID ${userInfo.group_id}` : "Нет группы"}</p></div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </section>
  );
};

export default Profile;
